// Copyright (C) 2021 Bystronic Laser AG

export enum WidgetType {
  Undefined = 0,
  Echarts = 1,
  CameraView = 2,
  Map = 3,
  Slot = 4,
  Table = 5,
  KPI = 6,
}
